import React, { useEffect, useState } from "react";
import axios from "../../utils/axios";
import { Link } from "react-router-dom";

const OrderHistoryPage = () => {
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [expandedOrder, setExpandedOrder] = useState(null);

    useEffect(() => {
        const fetchOrders = async () => {
            try {
                const response = await axios.get(`/api/orders?page=${page}&limit=5`);
                setOrders(response.data.orders);
                setTotalPages(response.data.totalPages);
            } catch (error) {
                setError("Failed to load orders.");
            } finally {
                setLoading(false);
            }
        };

        fetchOrders();
    }, [page]);

    const handlePageChange = (newPage) => {
        setPage(newPage);
    };

    const toggleOrderDetails = (orderId) => {
        setExpandedOrder(expandedOrder === orderId ? null : orderId);
    };

    const truncateTitle = (title) => {
        return title.length > 80 ? `${title.slice(0, 77)}...` : title;
    };

    const getStatusLabel = (status) => {
        switch (status) {
            case -1: return "Cancelled";
            case 0: return "Ordered";
            case 1: return "Shipped";
            case 2: return "Delivered";
            default: return "Unknown";
        }
    };

    if (loading) {
        return <div className="text-center">Loading...</div>;
    }

    if (error) {
        return <div className="text-center text-red-500">{error}</div>;
    }

    return (
        <div className="container mx-auto p-6 bg-white shadow-md rounded-lg">
            <h1 className="text-3xl font-semibold text-center mb-6">Order History</h1>
            <div className="overflow-x-auto">
                <table className="min-w-full bg-white border border-gray-300">
                    <thead className="bg-gray-100">
                        <tr>
                            <th className="px-4 py-2 text-left">Order ID</th>
                            <th className="px-4 py-2 text-left">Created At</th>
                            <th className="px-4 py-2 text-left">Subtotal</th>
                            <th className="px-4 py-2 text-left">Tax</th>
                            <th className="px-4 py-2 text-left">Shipping</th>
                            <th className="px-4 py-2 text-left">Grand Total</th>
                            <th className="px-4 py-2 text-left">Payment Method</th>
                            <th className="px-4 py-2 text-left">Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {orders.map((order) => (
                            <React.Fragment key={order._id}>
                                <tr onClick={() => toggleOrderDetails(order._id)} className="cursor-pointer hover:bg-gray-100">
                                    <td className="border px-4 py-2">{order._id}</td>
                                    <td className="border px-4 py-2">{(new Date(Number(order.createdAt))).toLocaleString()}</td>
                                    <td className="border px-4 py-2">${order.subTotal.toFixed(2)}</td>
                                    <td className="border px-4 py-2">${order.tax.toFixed(2)}</td>
                                    <td className="border px-4 py-2">${order.shipping.toFixed(2)}</td>
                                    <td className="border px-4 py-2">${order.grandTotal.toFixed(2)}</td>
                                    <td className="border px-4 py-2">{order.paymentMethod}</td>
                                    <td className="border px-4 py-2">{getStatusLabel(order.status)}</td>
                                </tr>
                                {expandedOrder === order._id && (
                                    <tr>
                                        <td colSpan="8" className="border-t">
                                            <div className="p-4">
                                                <ul className="list-disc pl-5">
                                                    {order.items.map((item) => (
                                                        <li key={item.pid} className="flex items-center justify-between">
                                                            <div className="flex items-center">
                                                                <Link to={`/product/${item.pid}`} className="flex items-center text-blue-500 hover:underline">
                                                                    <img src={item.cover} alt={item.title} className="w-16 h-16 object-cover mr-4" />
                                                                    <span>{truncateTitle(item.title)}</span>
                                                                </Link>
                                                            </div>
                                                            <span>
                                                                ${item.price.toFixed(2)} x {item.quantity}
                                                            </span>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </td>
                                    </tr>
                                )}
                            </React.Fragment>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className="flex justify-between mt-4">
                <button
                    disabled={page === 1}
                    onClick={() => handlePageChange(page - 1)}
                    className={`py-2 px-4 rounded-lg transition-all duration-300 ${page === 1 ? 'bg-gray-300 text-gray-500 cursor-not-allowed' : 'bg-blue-500 text-white hover:bg-blue-700'}`}
                >
                    Previous
                </button>
                <span className="self-center">Page {page} of {totalPages}</span>
                <button
                    disabled={page === totalPages}
                    onClick={() => handlePageChange(page + 1)}
                    className={`py-2 px-4 rounded-lg transition-all duration-300 ${page === totalPages ? 'bg-gray-300 text-gray-500 cursor-not-allowed' : 'bg-blue-500 text-white hover:bg-blue-700'}`}
                >
                    Next
                </button>
            </div>
        </div>
    );
};

export default OrderHistoryPage;

